import { render, staticRenderFns } from "./SelectionArrows.vue?vue&type=template&id=c49d4f40&scoped=true&"
import script from "./SelectionArrows.vue?vue&type=script&lang=ts&"
export * from "./SelectionArrows.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./SelectionArrows.vue?vue&type=style&index=0&id=c49d4f40&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c49d4f40",
  null
  ,true
)

export default component.exports